import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class TemporaryOrder extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/order/temporary`)
  }

  accept(orderId, driverId, showProgress) {
    return this._request({
      action: `${orderId}/${driverId}/accept`,
      method: 'PATCH',
      showProgress
    })
  }

  cancel(model, showProgress) {
    const { id } = model
    delete model.id

    return this._request({
      action: id,
      method: 'DELETE',
      body: model,
      showProgress
    })
  }
}
